// extracted by mini-css-extract-plugin
module.exports = {"lightAqua":"#97fae9","lightGreenishBlue":"#5df5cf","lightGreenishBlueTwo":"#5ef4ce","dirtyBlue":"#3a8c9e","white":"#ffffff","charcoalGrey":"#384243"};